module.exports = __webpack_public_path__ + "static/media/plus-deep-blue.e69f446d.svg";